import * as React from 'react'
import { useTheme } from '@mui/material'

const CircleCheckIcon = (props) => {
  const theme = useTheme()

  return (
    <svg width={118} height={118} viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M116.857 54.1V59.39C116.85 71.7894 112.835 83.8544 105.411 93.7855C97.9866 103.717 87.551 110.982 75.6605 114.497C63.7699 118.013 51.0614 117.591 39.4304 113.294C27.7993 108.997 17.8689 101.055 11.1202 90.6531C4.37146 80.2512 1.16598 67.9464 1.98182 55.5738C2.79766 43.2013 7.59112 31.4239 15.6473 21.9982C23.7035 12.5725 34.5907 6.00348 46.6853 3.27087C58.7798 0.53826 71.4337 1.78847 82.7597 6.83503M116.857 13.3901L59.3572 70.9476L42.1072 53.6976"
        stroke={props.color ? props.color : theme.palette.icon.success.color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default CircleCheckIcon
